import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import FloatingNextNav from './FloatingNextNav';
import EbookBanner from './EbookBanner';

const Layout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Navbar />
      <EbookBanner />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <FloatingNextNav />
    </div>
  );
};

export default Layout;